import type { RetellAIAgent } from '../../types/aiAgent';

interface ViewAIAgentModalProps {
  agent: RetellAIAgent;
  onClose: () => void;
}

export function ViewAIAgentModal({ agent, onClose }: ViewAIAgentModalProps) {
  const labelClass = 'text-xs font-medium text-gray-500 uppercase tracking-wide';
  const valueClass = 'text-sm text-gray-900 mt-0.5';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-lg mx-4 max-h-[90vh] flex flex-col">
        <div className="px-6 pt-6 pb-4 overflow-y-auto flex-1">
          <h2 className="text-lg font-bold text-gray-900 mb-4">View AI Agent</h2>

          <div className="space-y-4">
            <div>
              <p className={labelClass}>Status</p>
              <p className="mt-1">
                <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full ${agent.active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                  {agent.active ? 'Active' : 'Inactive'}
                </span>
              </p>
            </div>

            <div>
              <p className={labelClass}>Retell Agent Id</p>
              <p className={valueClass}>{agent.retellAgentId}</p>
            </div>

            <div>
              <p className={labelClass}>Name</p>
              <p className={valueClass}>{agent.name}</p>
            </div>

            <div>
              <p className={labelClass}>Context Data</p>
              {!agent.contextData?.length ? (
                <p className="text-sm text-gray-400 mt-0.5">None</p>
              ) : (
                <div className="mt-1 border border-gray-200 rounded-lg divide-y divide-gray-100">
                  {agent.contextData.map((item, i) => (
                    <div key={i} className="px-3 py-2 space-y-0.5">
                      <p className="text-sm font-medium text-gray-700">{item.label}</p>
                      <p className="text-xs text-gray-500">Key: {item.key}</p>
                      {item.default && <p className="text-xs text-gray-500">Default: {item.default}</p>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
